import React from "react";

import { DefaultObject, ZoomedImage } from "./index";
import { Grid } from "semantic-ui-react";

//import { KEYWORDS } from "../../shared/constants";

class Container extends DefaultObject {
  render() {
    const images = this.props.obj.ALLIMAGES || this.props.obj.URL_IIIF_MANIFEST;
    const renderImage = images && images.length > 0;

    return (
      <Grid>
        <Grid.Column width={16}>
          <div className={images ? "o-book" : "o-canvas"}>
            {renderImage && (
              <ZoomedImage key={this.props.obj.ID[0]} obj={this.props.obj} />
            )}
            {this.state.children && this.children()}
          </div>
        </Grid.Column>
      </Grid>
    );
  }
}

export default Container;
